import { render, staticRenderFns } from "./ztbb.vue?vue&type=template&id=6cc17e66&scoped=true&"
import script from "./ztbb.vue?vue&type=script&lang=js&"
export * from "./ztbb.vue?vue&type=script&lang=js&"
import style0 from "./ztbb.vue?vue&type=style&index=0&id=6cc17e66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc17e66",
  null
  
)

export default component.exports